// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1qJeE","time":"time-2Voz7"};